module.exports = __webpack_public_path__ + "img/plus.79564d07.svg";